import { RefObject, useEffect } from 'react';

/** Block horizontal trackpad gestures from triggering browser back/forward. */
export const useSpaceWidgetCarouselWheel = (
  containerRef: RefObject<HTMLElement | null>
) => {
  useEffect(() => {
    const element = containerRef.current;

    if (!element) {
      return undefined;
    }

    const handleWheel = (event: WheelEvent) => {
      if (Math.abs(event.deltaX) <= Math.abs(event.deltaY)) {
        return;
      }

      event.preventDefault();
    };

    element.addEventListener('wheel', handleWheel, { passive: false });

    return () => {
      element.removeEventListener('wheel', handleWheel);
    };
  }, [containerRef]);
};
